import { Modal } from 'ant-design-vue';

const defaultOptions = {
  width: 800,
  centered: true,
  class: 'custom-modal',
  cancelText: 'Cancel',
};

/**
 * Показывает диалог подтверждения удаления
 * @param {Object} options - Опции диалога
 * @param {string} options.title - Заголовок
 * @param {string} options.content - Содержимое
 * @param {Function} options.onOk - Callback при подтверждении
 */
export function confirmDelete({ title, content, onOk }) {
  Modal.confirm({
    ...defaultOptions,
    title: title || 'Delete',
    content,
    okText: 'Delete',
    okType: 'danger',
    onOk,
  });
}

/**
 * Показывает предупреждение
 * @param {Object} options - Опции диалога
 * @param {string} options.title - Заголовок
 * @param {string} options.content - Содержимое
 */
export function showWarning({ title, content }) {
  Modal.warning({
    ...defaultOptions,
    title,
    content,
    okText: 'OK',
  });
}

/**
 * Показывает диалог подтверждения с кастомными опциями
 * @param {Object} options - Опции диалога
 * @param {string} options.title - Заголовок
 * @param {string} options.content - Содержимое
 * @param {string} options.okText - Текст кнопки подтверждения
 * @param {string} options.okType - Тип кнопки (primary, danger, etc.)
 * @param {Function} options.onOk - Callback при подтверждении
 */
export function confirmAction({
  title, content, okText, okType, onOk,
}) {
  Modal.confirm({
    ...defaultOptions,
    title,
    content,
    okText: okText || 'Confirm',
    okType: okType || 'primary',
    onOk,
  });
}
